import React from "react";

import { useListContext } from "./List.hooks";

import { Typography } from "@/components/ui/typography";
import { cn } from "@/components/ui/utils";

/**
 * A heading over the rows of one group. ``isSticky`` keeps it at the top of
 * the list while its rows scroll beneath it, until the next group's heading
 * takes its place.
 */
export function ListItemGroup({
  value,
  isSticky = false,
}: {
  value: React.ReactNode;
  isSticky?: boolean;
}) {
  const { classes } = useListContext();
  return (
    <div
      className={cn(
        isSticky
          ? [
              classes.listGroup,
              "sticky top-0 z-1 bg-popover [border-bottom-width:1px] [border-bottom-style:solid] border-border",
            ]
          : classes.listItem,
      )}
    >
      {typeof value === "string" ? (
        <Typography
          level="body-xs"
          className="text-muted-foreground/80 uppercase"
        >
          {value}
        </Typography>
      ) : (
        value
      )}
    </div>
  );
}
